import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { TitleStrategy } from '@angular/router';
import { provideLoadingBarInterceptor } from '@ngx-loading-bar/http-client';
import { provideLoadingBarRouter } from '@ngx-loading-bar/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoggerModule } from 'ngx-logger';
import { provideToastr } from 'ngx-toastr';
import { routingProvider } from 'src/app/app-routing.module';
import { provideEnvironmentConfig } from 'src/app/shared/providers/http/http.provider';
import { WindowProvider } from 'src/app/shared/providers/window/window.provider';
import { environment } from '../environment/environment';
import { bodyEncryptionInterceptor } from './shared/interceptors/body-encryption/body-encryption.interceptor';
import { indexeddbCacheInterceptor } from './shared/interceptors/indexeddb-cache/indexeddb-cache.interceptor';
import { jwtInterceptor } from './shared/interceptors/jwt/jwt.interceptor';
import { credentialsInterceptor } from './shared/interceptors/with-credential/credentials.interceptor';
import { AppInjectorProvider } from './shared/providers/app-injector.provider';
import { FavIconProvider } from './shared/services/images/images.service';
import { LoggerProvider } from './shared/providers/logger.provider';
import { TitleStrategyService } from './shared/services/titleStrategy/title-strategy.service';
import { WebConfigProvider } from './shared/providers/webconfig.provider';
import { GlobalErrorHandlerProvider } from './shared/providers/global-error-hanlder.provider';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideMarkdown } from 'ngx-markdown';
import { signalFormsConfig } from './shared/providers/signal-form-config.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    // custom providers
    WebConfigProvider,
    AppInjectorProvider,
    LoggerProvider,
    FavIconProvider,
    WindowProvider,
    GlobalErrorHandlerProvider,
    { provide: TitleStrategy, useClass: TitleStrategyService },
    { provide: LOCALE_ID, useValue: 'en-ZA' },
    routingProvider,
    // old modules
    importProvidersFrom(LoggerModule.forRoot(environment.ngxLoggerConfig)),
    // angular providers
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideEnvironmentConfig({
      environment,
    }),
    provideHttpClient(
      withInterceptors([credentialsInterceptor, indexeddbCacheInterceptor, bodyEncryptionInterceptor, jwtInterceptor]),
      withInterceptorsFromDi(),
    ),
    provideLoadingBarInterceptor(),
    provideLoadingBarRouter(),
    signalFormsConfig,
    // @deprecated
    provideAnimations(),
    // 3rd party providers
    provideMarkdown(),
    provideToastr({
      timeOut: 7000,
      extendedTimeOut: 2000,
      closeButton: true,
      progressBar: true,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
        useHttpBackend: true,
      }),
    }),
  ],
};
